import { fromZonedTime } from 'date-fns-tz';

class Countdown extends HTMLElement {
  constructor() {
    super();

    const endDateString = this.getAttribute('data-date-end');
    const minutesLimit = this.getAttribute('data-minutes-limit');
    this.customRedirect = this.getAttribute('data-custom-redirect');

    if (minutesLimit) {
      const minutes = parseInt(minutesLimit);
      if (isNaN(minutes)) {
        this.hide();
        console.error('Invalid minutes limit format');
        return;
      }
      this.endDate = this.getFlexibleDate(minutes);
      this.redirect = false;
    } else if (endDateString) {
      this.endDate = fromZonedTime(`${endDateString}T23:59:59`, 'America/New_York');
      if (isNaN(this.endDate)) {
        this.hide();
        console.error('Invalid date format');
        return;
      }
    } else {
      this.hide();
      console.error('Missing data-date-end or data-minutes-limit attributes');
      return;
    }

    this.warp = this.querySelector('[data-countdown-wrap]');
    this.daysWrap = this.querySelector('[data-countdown-days-wrap]');
    this.hoursWrap = this.querySelector('[data-countdown-hours-wrap]');
    this.minutesWrap = this.querySelector('[data-countdown-minutes-wrap]');
    this.secondsWrap = this.querySelector('[data-countdown-seconds-wrap]');
    this.days = this.querySelector('[data-countdown-days]');
    this.hours = this.querySelector('[data-countdown-hours]');
    this.minutes = this.querySelector('[data-countdown-minutes]');
    this.seconds = this.querySelector('[data-countdown-seconds]');
    this.daysLabel = this.querySelector('[data-countdown-days-label]');

    this.startCountdown();
  }

  startCountdown() {
    const now = new Date();
    const diff = this.endDate - now;

    if (diff < 0) {
      this.hide();
      return;
    }

    this.update();

    this.interval = setInterval(() => {
      this.update();
    }, 1000);

    this.warp.classList.remove('blur-sm');
  }

  hide() {
    this.style.display = 'none';

    if (this.redirect) {
      if (this.customRedirect) {
        window.location.href = this.customRedirect;
      } else {
        window.location.href = '/';
      }
    }
  }

  getFlexibleDate(minutes) {
    const urlKey = `expiration_${window.location.href}`;

    const storedDate = localStorage.getItem(urlKey);

    if (storedDate) {
      return new Date(storedDate);
    }

    const newExpiration = new Date(Date.now() + minutes * 60 * 1000);
    localStorage.setItem(urlKey, newExpiration.toISOString());

    return newExpiration;
  }

  update() {
    const now = new Date();
    const diff = this.endDate - now;

    if (diff < 0) {
      this.hide();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;

    this.daysLabel.textContent = days === 1 ? 'Day' : 'Days';

    if (days === 0) {
      this.daysWrap.style.display = 'none';
    }
  }
}
customElements.define('countdown-timer', Countdown);
